
import { Edge } from 'reactflow';

export type INodeIdKey = 'patient' | 'community-group' | 'financial-group' | 'school-group' | 'medical-group' | 'specialists-group';

export type IEdgeHandleIdKey = 'community-handle' | 'financial-handle' | 'school-handle' | 'medical-handle' | 'specialists-handle';

type IHouseholdEdge = Edge & {
    source: INodeIdKey
    target: INodeIdKey
    sourceHandle: IEdgeHandleIdKey
}

export const householdConnections: IHouseholdEdge[] = [{
    id: 'patient-community-group',
    source: 'patient',
    sourceHandle: 'community-handle',
    target: 'community-group'
},{
    id: 'patient-financial-group',
    source: 'patient',
    sourceHandle: 'financial-handle',
    target: 'financial-group'
},{
    id: 'patient-school-group',
    source: 'patient',
    sourceHandle: 'school-handle',
    target: 'school-group'
},{
    id: 'patient-medical-group',
    source: 'patient',
    sourceHandle: 'medical-handle',
    target: 'medical-group'
},{
    id: 'patient-specialists-group',
    source: 'patient',
    sourceHandle: 'specialists-handle',
    target: 'specialists-group'
}];
